import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { Icon } from '@millionshow/client-libs';
import { ApplicationStep } from '../../../interfaces/booth-application.interface';

@Component({
  selector: 'app-step-indicator',
  standalone: true,
  imports: [CommonModule, Icon],
  template: `
    <div class="step-indicator gap-1.5!">
      @for (step of steps(); track step.key; let i = $index) {
      <div
        class="step-item"
        [class.active]="currentStep() === step.key"
        [class.completed]="isStepCompleted(i)">
        <div class="step-circle"></div>
        <span class="step-label">{{ step.label }}</span>
        @if (currentStep() === step.key) {
        <app-icon
          name="material-symbols:check-small-rounded"
          class="text-primary-500 size-5!" />
        }
      </div>
      @if (i < steps().length - 1) {
      <app-icon
        name="material-symbols:arrow-forward-ios"
        class="text-gray-400 size-3!" />
      } }
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        width: 100%;
      }

      .step-indicator {
        display: flex;
        align-items: center;
        justify-content: start;
        gap: 12px;
      }

      .step-item {
        display: flex;
        align-items: center;
        gap: 8px;
        position: relative;
      }

      .step-circle {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: #d1d5db;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.3s ease;
        position: relative;
        z-index: 2;
        flex-shrink: 0;
      }

      .step-item.active .step-circle {
        background-color: #16ae67;
      }

      .step-label {
        font-size: 0.9375rem;
        font-weight: 500;
        color: #9ca3af;
        text-align: center;
        white-space: nowrap;
      }

      .step-item.active .step-label {
        color: #16ae67;
        font-weight: 600;
      }

      .step-item.completed .step-label {
        color: #111827;
      }
    `,
  ],
})
export class StepIndicatorComponent {
  steps = input.required<{ key: ApplicationStep; label: string }[]>();
  currentStep = input.required<ApplicationStep>();

  isStepCompleted(stepIndex: number): boolean {
    const currentIndex = this.steps().findIndex(
      s => s.key === this.currentStep()
    );
    return currentIndex > stepIndex;
  }
}
